import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.verifyCandidateValidaton = function(){
        const dictonary = {
          custom: {
            mobile: {
              required: () => t.t(dictEnum.LBL_Mobile) + t.t(dictEnum.WARN_IsRequired)
            },
            dob: {
              required: () => t.t(dictEnum.LBL_DateofBirth) + t.t(dictEnum.WARN_IsRequired)
            },
          }
        };
      Validator.localize('en', dictonary);
    }   
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/VerifyCandidate/VerifyCandidateValidaton.js